module.exports = __webpack_public_path__ + "static/media/ic_cajero.265cb026.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_cajero.webp
// module id = 170
// module chunks = 1